import {
  ButtonContainer,
  CloseButton,
} from 'src/components/Notifications/GeneralNotification/Notifications.styles';
import React from 'react';
import { IGenericNotification } from 'src/components/Notifications/GeneralNotification/GenericNotification';

export const CloseButtonDefault = ({
  CloseButtonComponent,
  onClose,
}: IGenericNotification) => {
  return (
    <ButtonContainer>
      {CloseButtonComponent ? (
        <CloseButtonComponent />
      ) : (
        <CloseButton onClick={onClose} />
      )}
    </ButtonContainer>
  );
};
